import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import rightMark from "../../../../assets/image/right-mark.png";
import pr1 from "../../../../assets/pr/pr-1.jpg";
import pr2 from "../../../../assets/pr/pr-2.jpg";
import pr3 from "../../../../assets/pr/pr-3.jpg";
import pr4 from "../../../../assets/pr/pr-4.jpg";
import pr5 from "../../../../assets/pr/pr-5.jpg";
import pr6 from "../../../../assets/pr/pr-6.jpg";
import pr7 from "../../../../assets/pr/pr-7.jpg";
import pr8 from "../../../../assets/pr/pr-8.jpg";
import pr9 from "../../../../assets/pr/pr-9.jpg";
import pr10 from "../../../../assets/pr/pr-10.jpg";
import pr11 from "../../../../assets/pr/pr-11.jpg";
import pr12 from "../../../../assets/pr/pr-12.jpg";
import pr13 from "../../../../assets/pr/pr-13.jpg";

export default function CenterMode() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);
  const options2 = {
    loop: true,
    items: 3,
    navigation: true,
    dots: false,
    autoplay: true,
    stagePadding: 5,
    ltr: true,
  };
  return (
    <div className="vs-slider-container">
      <div className="private-listing-slider">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6">
              <p className="progress-text"> INSIDE THE PROCESS</p>
              <h1 className="heading-private">How Private Listings Work</h1>
              <p className="sub-heading-private">
                Not every home is meant to be seen by the public. Our process
                connects qualified buyers with private properties in a secure,
                discreet, and intentional way.
              </p>
              <div className="property-list d-flex flex-column">
                <div className="d-flex mb-3 align-items-center">
                  <img src={rightMark} alt="" />
                  <p>Reduced visibility, greater privacy</p>
                </div>
                <div className="d-flex mb-3 align-items-center">
                  <img src={rightMark} alt="" />
                  <p>Tailored opportunities shared only with approved buyers</p>
                </div>
              </div>
              <div className="small-slider-property-container">
                <Slider
                  {...options2}
                  asNavFor={nav1}
                  ref={(slider) => (sliderRef2 = slider)}
                  slidesToShow={3}
                  swipeToSlide={true}
                  focusOnSelect={true}
                >
                  <div>
                    <img src={pr1} className="small-property-img" alt="" />
                  </div>
                  <div>
                    <img src={pr2} className="small-property-img" alt="" />
                  </div>
                  <div>
                    <img src={pr3} className="small-property-img" alt="" />
                  </div>
                  <div>
                    <img src={pr4} className="small-property-img" alt="" />
                  </div>
                  <div>
                    <img src={pr5} className="small-property-img" alt="" />
                  </div>
                  <div>
                    <img src={pr6} className="small-property-img" alt="" />
                  </div>
                </Slider>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="image-container">
                <Slider asNavFor={nav2} ref={(slider) => (sliderRef1 = slider)}>
                  <div>
                    <img src={pr1} alt="" />
                  </div>
                  <div>
                    <img src={pr2} alt="" />
                  </div>
                  <div>
                    <img src={pr3} alt="" />
                  </div>
                  <div>
                    <img src={pr4} alt="" />
                  </div>
                  <div>
                    <img src={pr5} alt="" />
                  </div>
                  <div>
                    <img src={pr6} alt="" />
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
